export const isPostSeen = (post) => post.isRead;
